import { FC } from "react";
import styles from './Notification.module.less';
import banner from '../assets/banner3.png';
import { Breadcrumb } from 'antd';
import { useNavigate } from "react-router";
import NotificationList from '../components/NotificationList';

const Index: FC = () => {
    const navigate = useNavigate();
    return (
        <div className={styles.body}>
            <div style={{height: '280px'}}>
                <img src={banner} alt="" />
            </div>
            <div className={styles.fix}>
                <div style={{width: '1200px', position: 'relative'}}>
                    <div className={styles.banner}>
                        <div className={styles.title}>
                            通知公告
                        </div>
                    </div>
                    <div className={styles.breadcrumb}>
                        <Breadcrumb>
                            <Breadcrumb.Item className={styles.bread} onClick={() => navigate('/')}>首页</Breadcrumb.Item>
                            <Breadcrumb.Item className={styles.bread}>通知公告</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                </div>
            </div>
            <div className={styles.list}>
                <NotificationList width='960px' data={[{},{},{}]}></NotificationList>
            </div>
        </div>
    );
}

export default Index;